<template>
    <div class="progressbar">
        <div :style="progressStyle" :class="calcClass">
            <slot>
                <span class="label" v-text="label"></span>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default : 0,
                type: Number
            },
            min: {
                default: 0,
                type: Number
            },
            max: {
                default : 100,
                type: Number
            },
            label: {
                default: '',
                type: String
            },
            // show reversed progressbar
            // from fulled to empty
            reversed : {
                default : false
            },
            // usage example:
            // turn progress color to orange if less than 10 min remaining
            // to red if less than 2 min remaining
            external_class : {
                default : null,
                required : false
            },
        },
        computed: {
            progressStyle: function () {
                let range = this.max -this.min;
                let final_value = this.value - this.min;
                let percent = 100 * (final_value/range)

                if(this.reversed){
                    return {
                        width: 100 - percent + '%',
                    }
                } else {
                    return {
                        width: percent + '%',
                    }
                }

            },

            calcClass (){
                let finalClass = 'bar '

                if(this.external_class && this.external_class.red){
                    finalClass += 'red '
                }

                if(this.external_class && this.external_class.orange){
                    finalClass += 'orange '
                }

                return finalClass
            }

        }
    }
</script>
